@if (isPharmacyUser$ | async) {
  <div class="col-12 mb-3">
    <app-pharmacy-association
      [appliedVouchers]="
        dataForFluConfirmation?.[0]?.appliedVouchers
      "></app-pharmacy-association>
  </div>
}

<!--Reservation contact heading -->
<section class="col-md-12">
  <h3 class="font-bold mb-4">
    <!-- Things are inverted on order confirmation page -->
    @if (isReservationOverview) {
      {{
        ((isPharmacyUser$ | async) ? 'flu.physicianContact' : 'flu.contact')
          | cxTranslate
      }}
    } @else {
      {{
        ((isPharmacyUser$ | async) ? 'flu.contact' : 'flu.physicianContact')
          | cxTranslate
      }}
    }
  </h3>
</section>

<!--contact details-->
@if (isPharmacyUser$ | async) {
  <ng-container
    *ngTemplateOutlet="infContactTemplate; context: { data: infContact }">
  </ng-container>
} @else {
  <ng-container
    *ngTemplateOutlet="infContactTemplate; context: { data: userInfo }">
  </ng-container>
}

<ng-template #infContactTemplate let-data="data">
  <section class="d-flex flex-wrap contact-Main-Row">
    <section class="col-4 mb-2">
      <span class="font-bold">{{ 'selectVaccines.name' | cxTranslate }}</span>
    </section>
    <section class="col-8 mb-2">
      <span>{{ data?.name }}</span>
    </section>
    <section class="col-4 mb-2">
      <span class="font-bold">{{
        'orderConfirmation.email' | cxTranslate
      }}</span>
    </section>
    <section class="col-8 mb-2">
      <a
        href="{{ 'mailto:' + (data?.email ? data?.email : userEmail) }}"
        class="email-field"
        >{{
          data?.email || data?.influenzaContactInfos?.[0]?.email || userEmail
        }}</a
      >
    </section>

    <section class="col-4 mb-2" *ngIf="data?.billingAddress">
      <span class="font-bold">{{
        'orderConfirmation.address' | cxTranslate
      }}</span>
    </section>
    <section class="col-8 mb-2" *ngIf="data?.billingAddress">
      <span>{{ data?.billingAddress?.formattedAddress }}</span>
    </section>

    <section class="col-4 mb-2" *ngIf="data?.phoneNo || data?.phoneNumber">
      <span class="font-bold">{{
        'orderConfirmation.phone' | cxTranslate
      }}</span>
    </section>
    <section class="col-8 mb-2" *ngIf="data?.phoneNo || data?.phoneNumber">
      <span>{{ data?.phoneNo || data?.phoneNumber }}</span>
    </section>
  </section>
</ng-template>
<!--address-->
<section
  class="row mt-4 text-fixed-medium"
  *ngIf="!isReservationOverview && (isDirectUser$ | async)">
  <section class="col-lg-6 mb-4 mb-lg-0">
    <section class="col-md-12">
      <h4 class="font-bold">
        {{ 'addToCartItems.billingAddress' | cxTranslate }}
      </h4>
    </section>
    <section class="col-md-12">
      <span
        >{{ 'addToCartItems.accountNo' | cxTranslate }}:
        {{ billingAddress?.unitID }}</span
      >
    </section>
    <section class="col-md-12">
      <span>{{ billingAddress?.companyName }}</span>
    </section>
    <section class="col-md-12">
      <span>{{ billingAddress?.line1 }}, {{ billingAddress?.line2 }}</span>
    </section>
    <section class="col-md-12">
      <span
        >{{ billingAddress?.town }},
        {{ billingAddress?.region?.isocodeShort }}
        {{ billingAddress?.postalCode }}</span
      >
    </section>
  </section>
  <section class="col-lg-6">
    <section class="row">
      <section class="col-md-12 col-lg-12 col-xl-12 sold-Address-Div">
        <h4 class="font-bold">
          {{ 'addToCartItems.soldToAddress' | cxTranslate }}
        </h4>
      </section>
      <section class="col-md-12 col-lg-12 col-xl-12">
        <span
          >{{ 'addToCartItems.accountNo' | cxTranslate }}:
          {{ soldToAddress?.unitID }}</span
        >
      </section>
      <section class="col-md-12 col-lg-12 col-xl-12">
        <span>{{ soldToAddress?.companyName }}</span>
      </section>
      <section class="col-md-12 col-lg-12 col-xl-12">
        <span>{{ soldToAddress?.line1 }}, {{ soldToAddress?.line2 }}</span>
      </section>
      <section class="col-md-12 col-lg-12 col-xl-12">
        <span
          >{{ soldToAddress?.town }},
          {{ soldToAddress?.region?.isocodeShort }}
          {{ soldToAddress?.postalCode }}</span
        >
      </section>
    </section>
  </section>
</section>

<!-- Indirect billing message -->
<section
  class="col-12 mt-4 text-fixed-medium"
  *ngIf="!(isDirectUser$ | async) && (isPharmacyUser$ | async)">
  <h3 class="font-bold">{{ 'flu.billing-data' | cxTranslate }}</h3>
  <span>{{ 'flu.billing-data-message' | cxTranslate }}</span>
</section>
